import * as UnitHelper from './unit.helper';

let UnitService = function (Restangular) { 
  const Service = Restangular.all('admin/unit');

  let count = (query) => {
    return Service.customGET('count', query);
  }

  let save = (unit) => {
    if (unit.id) {
      let copyData = angular.copy(unit);
      delete copyData.id;
      return unit.customPUT(copyData);
    } else {
        return Service.post(unit);
    } 
  }

  let saveEvent  = (event, unit_id) => {
    if(event.id){
      return Restangular.all(`/v2/admin/events/${event.id}`).customPUT(event)
    }
    else{
      return Restangular.all(`/v2/admin/events/${unit_id}`).post(event)
    }
  }

  let editEvent  = (event) => {
    return Restangular.all(`/v2/admin/events/${event.id}`).customPUT(event)
  }

  let getEvents  = (unitID) => {
    return Restangular.all(`/v2/admin/events/unit`).customGET(`${unitID}`)
  }

  let getEventDetail  = (id) => {
    return Restangular.all(`/v2/admin/events`).customGET(id)
  }
  
  let removeSpecialHour  = (id) => {
    return Restangular.all(`/v2/admin/special_hours/${id}`).remove()
  }

  let removeEvent  = (id) => {
    return Restangular.all(`/v2/admin/events/${id}`).remove()
  }

  let index = (query) => {
    query = query || {};
    query.deleted_at = 'null';
    return Service.getList(query);
  }

  let load = (query) => {
    query.deleted_at = 'null';
    return new Promise((resolve, reject) => {
        count(query)
        .then(response => {
            let count = response[0];
            index(query)
            .then(data => {
                resolve({count, data});
            })
            .catch(err => {
                reject(err);
            });
        })
        .catch(err => {
            reject(err);
        });
    });
  }

  let show = (id) => {
    return Service.get(id);
  }

  let destroy = (unit) => {
    unit.deleted_at = moment();
    return unit.save();
  }

  let downloadReport = () => { 
    return Restangular.one('unit/report').get()
  }

  const rejectAttendanceHour = payload => Service.customPUT(payload.data, `${payload.id}/attendance_hour/reject`);

  const approvalAttendanceHour = async unitId => Service.customPUT({
    "access_token": await UnitHelper.getToken()
    }, `${unitId}/attendance_hour/approval`);

  return { load, save, show, destroy, downloadReport, rejectAttendanceHour, approvalAttendanceHour, saveEvent, getEvents, getEventDetail, editEvent, removeSpecialHour, removeEvent} ;
};

UnitService.$inject = ['Restangular'];

export default UnitService;



// WEBPACK FOOTER //
// ./client/app/components/unit/unit.service.js